var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav" }, [
    _c("div", { staticClass: "nav-container" }, [
      _c(
        "div",
        { staticClass: "logo" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", {
              staticClass: "full",
              attrs: { src: "/static/logo-head-blue.svg" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "head",
              attrs: { src: "/static/logo-head-blue.svg" }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "links" }, [
        _c("li", [
          _vm.isLoggedIn
            ? _c(
                "button",
                {
                  staticClass: "default-gray",
                  on: {
                    click: function($event) {
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("\n\t\t\t\t\tSign Out\n\t\t\t\t")]
              )
            : !_vm.isLoggedIn
              ? _c(
                  "button",
                  {
                    staticClass: "blue",
                    on: {
                      click: function($event) {
                        _vm.$router.push("/login")
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\t\tSign In\n\t\t\t\t")]
                )
              : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c42558f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c42558f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/Navigation.vue
// module id = null
// module chunks = 